import * as React from 'react';
import { withDataFetch } from '../hoc/withDataFetch';
import {
  WidgetWrapper,
  WidgetText,
} from '../core/DashbardGridStyledComponents';

export interface CounterWidgetProps {
  data: object;
  options: object;
}
const CounterWidget: React.FC<any> = ({ data, options }) => {
  const { value } = data;
  const { title, titleClasses, valueClasses } = options;
  return (
    <WidgetWrapper>
      <WidgetText {...titleClasses}>{title}</WidgetText>
      <WidgetText size="4rem" bold color="#c53030" {...valueClasses}>
        {value}
      </WidgetText>
    </WidgetWrapper>
  );
};

export default withDataFetch(CounterWidget);
